export enum OrderType {
  DELIVERY = 'DELIVERY',
  DINE_IN = 'DINE_IN',
  TAKE_AWAY = 'TAKE_AWAY',
}
